import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const CheckYesIcon = forwardRef<any, any>((props, ref) => {
  const width = "49";
  const height = "48";
  const viewBox = `0 0 ${width} ${height}`;

  return (
    <Icon viewBox={viewBox} {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#33AB6F"
      />
      <g filter="url(#filter0_dd_1404_4215)">
        <path
          d="M40.6001 16.5983C40.8623 16.8626 40.8636 17.2955 40.6035 17.5605L21.2471 37.3281C20.987 37.5937 20.5618 37.5937 20.3017 37.3281L15.9616 32.895C15.7015 32.6294 15.2762 32.1951 15.0161 31.9295L9.79273 26.5945C9.53263 26.3288 9.53263 25.8946 9.79273 25.6289L14.1342 21.1952C14.3943 20.9296 14.8195 20.9296 15.0796 21.1952L20.3037 26.5296C20.5638 26.7952 20.989 26.7952 21.2491 26.5296L35.2805 12.2002C35.5406 11.9345 35.9672 11.9332 36.2293 12.1967L40.6001 16.5983Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1404_4215"
          x="1.59766"
          y="5"
          width="47.1992"
          height="41.5273"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1404_4215"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1404_4215"
            result="effect2_dropShadow_1404_4215"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1404_4215"
            result="shape"
          />
        </filter>
      </defs>
    </Icon>
  );
});

export { CheckYesIcon };
